var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-text",class:{'ellipsis-2':_vm.isEllipsis2,bold:_vm.bold,display:_vm.display,h1:_vm.h1,h2:_vm.h2,h3:_vm.h3,h4:_vm.h4,h5:_vm.h5,h6:_vm.h6,remark:_vm.remark,'light-gray':_vm.lightGray,required:_vm.required,'remove-style':_vm.removeStyle}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }